import '@ant-design/v5-patch-for-react-19';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from '@store/index';
import { ThemeProvider } from '@context/ThemeContext';
import { AppProvider } from '@context/AppContext';
import { AppRouter } from '@router/index';
import { LoadingFallback } from '@components/shared/LoadingFallback';

export default function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<LoadingFallback />} persistor={persistor}>
        <ThemeProvider>
          <AppProvider>
            <AppRouter />
          </AppProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}
